export default __webpack_public_path__ + "static/media/icon_youtube.5b8ee46b.webp";